export default "__VITE_ASSET__CjBW8suy__"